var map = {
	"./bourse-direct.svg": 33823,
	"./boursorama.svg": 16263,
	"./charles-schwab.svg": 60431,
	"./degiro.svg": 16594,
	"./etoro.svg": 33087,
	"./etrade.svg": 27014,
	"./fidelity.svg": 88811,
	"./hsbc.svg": 85250,
	"./icon/degiro.svg": 20290,
	"./interactive-brokers.svg": 11350,
	"./m1-finance.svg": 33134,
	"./robinhood.svg": 63466,
	"./saxobanque.svg": 3134,
	"./td-ameritrade.svg": 68159,
	"./trading-212.svg": 21881,
	"./vanguard.svg": 23576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92379;